import { InMemoryCache, InMemoryCacheConfig } from '@apollo/client';
import possibleTypes from './possibleTypes.json';
import { createFragmentRegistry } from '@apollo/client/cache';
import { typePolicies } from '~/apollo/typePolicies';
import allFragments from '~/fragments/allFragments';

export const cacheConfig: InMemoryCacheConfig = {
  possibleTypes,
  typePolicies,
  // Read more here:
  // https://www.apollographql.com/docs/react/data/fragments#registering-named-fragments-using-createfragmentregistry
  fragments: createFragmentRegistry( allFragments ),
};

export function makeCache() {
  const cache = new InMemoryCache( cacheConfig );

  return cache;
}
